import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TermosPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 py-12 bg-muted/30">
        <div className="container max-w-4xl">
          <Card>
            <CardHeader>
              <CardTitle className="text-3xl font-display">Termos de Uso</CardTitle>
              <p className="text-muted-foreground">Última atualização: Janeiro de 2026</p>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <p className="text-muted-foreground mb-8">
                Ao acessar ou utilizar a plataforma JobWayX, o usuário concorda integralmente com estes Termos de Uso.
              </p>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">1. Objeto</h2>
                <p className="text-muted-foreground">
                  A JobWayX é uma plataforma digital que conecta candidatos a oportunidades de trabalho oferecidas por empresas.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">2. Cadastro e Responsabilidades do Usuário</h2>
                <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
                  <li>Fornecer informações verdadeiras e atualizadas</li>
                  <li>Manter a confidencialidade de suas credenciais</li>
                  <li>Utilizar a plataforma de forma ética e legal</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">3. Responsabilidades da JobWayX</h2>
                <ul className="list-disc pl-6 space-y-1 text-muted-foreground">
                  <li>Disponibilizar a plataforma de forma estável e segura</li>
                  <li>Proteger os dados pessoais conforme a LGPD</li>
                  <li>Não garantir contratação ou resposta das empresas</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">4. Conteúdos e Propriedade Intelectual</h2>
                <p className="text-muted-foreground">
                  Todos os conteúdos da plataforma são protegidos por direitos autorais, sendo vedada a reprodução sem autorização.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">5. Limitação de Responsabilidade</h2>
                <p className="text-muted-foreground">
                  A JobWayX não se responsabiliza por decisões tomadas por empresas ou candidatos com base nas informações da plataforma.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-display font-semibold mb-3">6. Suspensão e Encerramento</h2>
                <p className="text-muted-foreground">
                  A JobWayX poderá suspender ou encerrar contas que violem estes Termos ou a legislação vigente.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-display font-semibold mb-3">7. Foro</h2>
                <p className="text-muted-foreground">
                  Fica eleito o foro da comarca do domicílio da JobWayX, salvo disposição legal em contrário.
                </p>
              </section>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermosPage;
